import request from '@/utilsCloud/request'
import port from './port'

// 获取新闻列表
export function getNewsSlidshow(query) {
  return request({
    url: port.biz + '/news/getNewsSlidshow',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 获取新闻列表
export function getNewsInformationList(query) {
  return request({
    url: port.biz + '/news/getNewsInformationList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 获取考试列表
export function detailsNews(query) {
  return request({
    url: port.biz + '/news/detailsNews',
    headers: {
      isToken: false,
      isEntpId: false
    },
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/news.js